import { MultiValue } from 'react-select';

import useAdminTokenUsageFilters from '@features/admin-token-usage/hooks/useAdminTokenUsageFilters.tsx';
import InputCheckbox from '@components/InputCheckbox/ui/InputCheckbox.tsx';
import ReactSelect from '@components/StyledReactSelect/StyledReactSelect.tsx';
import { Option } from '@utils/react-select.ts';
import Box from '@mui/material/Box';
import CustomDatePicker from '@components/DatePicker';
import styles from './index.module.scss';

const intervalOptions: MultiValue<Option> = [
  { value: 'day', label: 'Day' },
  { value: 'week', label: 'Week' },
  { value: 'month', label: 'Month' },
  { value: 'quarter', label: 'Quarter' },
  { value: 'year', label: 'Year' },
];

const documentResultOptions: MultiValue<Option> = [
  { value: 'total', label: 'All' },
  { value: 'success', label: 'Successful' },
  { value: 'failed', label: 'Failed' },
];

const documentTypeOptions: MultiValue<Option> = [
  { value: 'demand_letter', label: 'Demand Letters' },
  { value: 'deposition_summary', label: 'Deposition Summaries' },
  { value: 'use_case', label: 'Use Cases' },
  { value: 'chat', label: 'AI Chats' },
  { value: 'prompt_preview', label: 'Prompt Previews' },
];

function AdminTokenUsageFilters() {
  const {
    showTokenCount,
    setShowTokenCount,
    selectedInterval,
    setSelectedInterval,
    documentResult,
    setDocumentResult,
    selectedDocumentTypes,
    setSelectedDocumentTypes,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
  } = useAdminTokenUsageFilters();

  return (
    <div className={styles.filtersContainer}>
      <div />
      <Box
        display="flex"
        gap={2}
        sx={{
          flexDirection: { xs: 'column', sm: 'column', lg: 'row' },
          flexGrow: { xs: 1, sm: 1, lg: 0 },
        }}
      >
        <CustomDatePicker
          selected={startDate}
          placeholder="Select a start date"
          onChange={setStartDate}
          prefix="From"
        />
        <CustomDatePicker
          selected={endDate}
          placeholder="Select an end date"
          onChange={setEndDate}
          prefix="To"
        />
        <ReactSelect
          value={selectedInterval}
          placeholder="Select interval"
          onChange={(newValue) =>
            newValue && setSelectedInterval(newValue as Option)
          }
          options={intervalOptions}
          className={styles.select}
        />
        <ReactSelect
          isMulti
          placeholder="Select document types"
          value={selectedDocumentTypes}
          onChange={(e) => setSelectedDocumentTypes(e as MultiValue<Option>)}
          options={documentTypeOptions}
          className={styles.multiSelect}
        />
        <ReactSelect
          value={documentResult}
          placeholder="Select result"
          onChange={(newValue) =>
            newValue && setDocumentResult(newValue as Option)
          }
          options={documentResultOptions}
          className={styles.select}
        />
        <div className={styles.toggler}>
          <InputCheckbox
            toggler
            name="showTokenCount"
            checked={showTokenCount}
            onChange={(e) => setShowTokenCount(e.target.checked)}
          />
          <div className={styles.textWrap}>
            <p className={styles.title}>Show Tokens</p>
          </div>
        </div>
      </Box>
    </div>
  );
}

export default AdminTokenUsageFilters;
